import { Button, ButtonVariant, Dialog, Size } from '@hourly-hds/components';
import { Alert as AlertIcon } from '@hourly-hds/icons/colored';
import { DialogButton } from './DialogButton';
import styles from './ErrorDialog.module.css';

export type ErrorDialogProps = {
  title?: string;
  content?: string;
  button?: DialogButton;
  onClose?: () => void;
};

const ErrorDialog = ({
  title = 'Error',
  content = 'Unexpected error occurred',
  button = { label: 'Dismiss', variant: ButtonVariant.Hollow },
  onClose = () => {},
}: ErrorDialogProps) => {
  return (
    <div className={styles.overlayWrapper}>
      <Dialog size={Size.Medium} onClose={onClose} open modal>
        <Dialog.Header>
          <header className={styles.header}>
            <AlertIcon className={styles.headerIcon} />
            {title}
          </header>
        </Dialog.Header>
        <Dialog.Content>
          <p className={styles.contentDescription}>{content}</p>
        </Dialog.Content>
        <Dialog.Footer>
          <Button
            label={button.label}
            onClick={() => {
              onClose?.();
              button.onClick?.();
            }}
            variant={button.variant}
          />
        </Dialog.Footer>
      </Dialog>
    </div>
  );
};

export default ErrorDialog;
